import axios from 'axios';

const list = (data) => axios.get('/safe/area/list', data);
const save = (data) => axios.post('/safe/area/save', data);
const del = (data) => axios.post('/safe/area/delete', data);


export default {
  list,
  save,
  del,

}


